import { TAGS } from "../../../../util/Data/DataModeling";

export const TAG_ERRORS = {
  EMTPY_KEY: `${TAGS.singular} key cannot be empty.`,
  DUPLICATE_KEY: `${TAGS.singular} key is duplicate.`,
};
